'use strict';

import React from 'react';
import clsx from 'clsx';
import { isExternal } from 'src/universal/utils/url/index';
import { SvgComponent } from './svg-component';

function getAttributes(props) {
  if (props.attribues) {
    return props;
  }
  const { href, ...attributes } = props;
  return { href, attributes };
}

function SvgIconImage(props) {
  const properties = getAttributes(props);
  if (!isExternal(properties.href)) {
    const { className } = props;
    const arrParts = String(properties.href).split('#');
    const svgKey = arrParts.length > 1 ? arrParts[1] : arrParts[0];
    return SvgComponent(svgKey, clsx('icon', className));
  } else {
    return (
      <svg className="icon" role="img" {...properties.attributes}>
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={properties.href} />
      </svg>
    );
  }
}

export default SvgIconImage;
